import Vue from 'vue'
import 'zq-component/lib/formPage/index.css'
import ZqFormPage from 'zq-component/lib/formPage/index.js'

Vue.use( {
  install(Vue) {
    Vue.use(ZqFormPage)
  },
})
